// removed by extract-text-webpack-plugin
module.exports = {"textArea":"CwTextArea-textArea","textAreaInvalid":"CwTextArea-textAreaInvalid"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwtextarea/CwTextArea.scss
// module id = 392
// module chunks = 0